import i18n, { t } from 'i18next';
import { get } from 'lodash';

import { DefaultMessage, DocumentPrefix, DocumentTypes, FileStorePath } from './constants';
import { TYPES } from '../actions/modal';
import { Language } from '../locale/constants';

export const getFileName = (fileName) => (fileName && fileName.replace(/\.[^/.]+$/, '')) || '';

export const checkDocumentFormat = (name) => {
    const fileName = getFileName(name);
    const isDocumentItem = Number.isInteger(+fileName);
    const isDefectItem = fileName.indexOf(DocumentPrefix.DEFECT) === 0;
    const isLibraryItem = fileName.indexOf(DocumentPrefix.LIBRARY) === 0;
    const needChange = fileName === name && (isDocumentItem || isDefectItem || isLibraryItem);
    let type = DocumentTypes.OTHER;
    if (isDefectItem) {
        type = DocumentTypes.DEFECT;
    } else if (isLibraryItem) {
        type = DocumentTypes.LIBRARY;
    } else if (isDocumentItem) {
        type = DocumentTypes.DOCUMENT;
    }

    return {
        fileName,
        type,
        needChange,
    };
};

export const getFileExtensions = (contentType) => {
    switch (contentType) {
        case 'application/pdf':
            return '.pdf';
    }

    return '';
};

export const checkExistValue = (value) => {
    return value !== null && value !== undefined; // && !isNaN(value);
};

export const isAndroid = () => {
    // eslint-disable-next-line no-undef
    return typeof device !== 'undefined' && device.platform === 'Android';
};

export const getFileStorePath = () => {
    return isAndroid() ? FileStorePath.ANDROIDDOWNLOAD : FileStorePath.LOCAL;
};

export const getErrorMessage = (error, messageType) => {
    if (!error.message && (!messageType || !DefaultMessage[messageType])) {
        return `An unhandled error has occurred please contact support. ${messageType && `${messageType}.`} ${error && `Error: ${error}`}`;
    }
    return error.message || `${DefaultMessage[messageType]}. ${error && `Details: ${error}`}`;
};

export const checkVersion = (appVersion, initialState) => {
    const stateVersion = get(initialState, 'version.application', '');

    return appVersion === stateVersion;
};

export const getTitle = (checkType, { route, rnt }) => {
    let title = '';
    switch (checkType) {
        case TYPES.CHECK_ALTITUDE:
            return (title = t('navigationRoute.editCheckAltitude'));

        case TYPES.SHORT_POINT:
            return (title = t('navigationRoute.editPointRoute', {
                route: route || rnt || '',
                rnt: rnt && route && rnt !== route ? `(${rnt})` : '',
            }));

        default:
            return title;
    }
};

export const deepEqual = (x, y) => {
    if (x === y) {
        return true;
    }
    if (typeof x === 'object' && x !== null && typeof y === 'object' && y !== null) {
        if (Object.keys(x).length !== Object.keys(y).length) {
            return false;
        }

        for (const prop in x) {
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop])) {
                    return false;
                }
            } else {
                return false;
            }
        }

        return true;
    }

    return false;
};

export const deepArrayCompare = (arr1, arr2) => {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        const obj1 = arr1[i];
        const obj2 = arr2[i];

        if (Object.keys(obj1).length !== Object.keys(obj2).length) {
            return false;
        }

        for (let key in obj1) {
            if (obj1[key] !== obj2[key]) {
                if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                    if (!deepEqual(obj1[key], obj2[key])) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        }
    }

    return true;
};

export const getTranslateText = (fieldName, obj) => {
    let field = i18n.language === Language.en ? `${fieldName}Eng` : fieldName;

    return obj && obj[field] ? obj[field] : obj && obj[fieldName];
};
